var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 11.5C9.5 11.2239 9.72386 11 10 11H19.5C19.7761 11 20 11.2239 20 11.5V20C20 20.2761 19.7761 20.5 19.5 20.5H10C9.72386 20.5 9.5 20.2761 9.5 20V11.5ZM10.5 12V19.5H19V12H10.5Z",
    fill: "#58486C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1C0 0.723858 0.223858 0.5 0.5 0.5H5.25C5.38706 0.5 5.5181 0.55626 5.6125 0.655625L10.3625 5.65563C10.4508 5.74855 10.5 5.87183 10.5 6V20C10.5 20.2761 10.2761 20.5 10 20.5H0.5C0.223858 20.5 0 20.2761 0 20V1ZM1 1.5V19.5H9.5V6.19964L5.03534 1.5H1Z",
    fill: "#58486C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6464 6.64449C14.8417 6.44923 15.1583 6.44923 15.3536 6.64449L19.8536 11.1445C20.0488 11.3398 20.0488 11.6563 19.8536 11.8516C19.6583 12.0469 19.3417 12.0469 19.1464 11.8516L14.6464 7.3516C14.4512 7.15634 14.4512 6.83976 14.6464 6.64449Z",
    fill: "#58486C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3716 6.66357C15.1869 6.45831 14.8708 6.44167 14.6655 6.6264L9.66551 11.1264C9.46026 11.3111 9.44362 11.6273 9.62835 11.8325C9.81308 12.0378 10.1292 12.0544 10.3345 11.8697L15.3345 7.3697C15.5397 7.18497 15.5564 6.86882 15.3716 6.66357Z",
    fill: "#58486C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 14.502C13.2761 14.502 13.5 14.7258 13.5 15.002L13.5 19.502C13.5 19.7781 13.2761 20.002 13 20.002C12.7239 20.002 12.5 19.7781 12.5 19.502L12.5 15.002C12.5 14.7258 12.7239 14.502 13 14.502Z",
    fill: "#58486C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 6.00195L5.5 6.00195C5.77614 6.00195 6 6.22581 6 6.50195C6 6.7781 5.77614 7.00195 5.5 7.00195L2.5 7.00195C2.22386 7.00195 2 6.7781 2 6.50195C2 6.22581 2.22386 6.00195 2.5 6.00195Z",
    fill: "#58486C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6.00195L8 6.00195C8.27614 6.00195 8.5 6.22581 8.5 6.50195C8.5 6.7781 8.27614 7.00195 8 7.00195L7 7.00195C6.72386 7.00195 6.5 6.7781 6.5 6.50195C6.5 6.22581 6.72386 6.00195 7 6.00195Z",
    fill: "#58486C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 9.00195C8.5 9.2781 8.27614 9.50195 8 9.50195L2.5 9.50195C2.22386 9.50195 2 9.2781 2 9.00195C2 8.72581 2.22386 8.50195 2.5 8.50195L8 8.50195C8.27614 8.50195 8.5 8.72581 8.5 9.00195Z",
    fill: "#58486C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 11.502C8.5 11.7781 8.27614 12.002 8 12.002L2.5 12.002C2.22386 12.002 2 11.7781 2 11.502C2 11.2258 2.22386 11.002 2.5 11.002L8 11.002C8.27614 11.002 8.5 11.2258 8.5 11.502Z",
    fill: "#58486C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 14.002C8.5 14.2781 8.27614 14.502 8 14.502L2.5 14.502C2.22386 14.502 2 14.2781 2 14.002C2 13.7258 2.22386 13.502 2.5 13.502L8 13.502C8.27614 13.502 8.5 13.7258 8.5 14.002Z",
    fill: "#58486C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 14.502C16.7761 14.502 17 14.7258 17 15.002L17 19.502C17 19.7781 16.7761 20.002 16.5 20.002C16.2239 20.002 16 19.7781 16 19.502L16 15.002C16 14.7258 16.2239 14.502 16.5 14.502Z",
    fill: "#58486C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.c7fdfc3d89e239bd3b9298f143ebfe46.svg";
export { ForwardRef as ReactComponent };